import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild, ViewChildren,SimpleChanges, QueryList } from '@angular/core';
import { MediaItem } from '../models/media-item';
import { DropMenuAction } from 'src/app/common/enums/enums';
import { DropMenuItem } from '../../drop-menu/models/DropMenuItem';
import { DropMenu } from '../../drop-menu/models/DropMenu';

@Component({
    selector: 'app-media-carousel',
    templateUrl: './media-carousel.component.html',
    styleUrls: ['./media-carousel.component.scss'],
    standalone: false
})
export class MediaCarouselComponent implements OnInit {
  dropMenu!: DropMenu;
  isCarouselActivate = true;
  leftView=0;
  rightView=0;
  isLeftView = false;
  isRightView = true;

  constructor() { }

  @Input() items: Array<MediaItem> = [];   
  @Output() action = new EventEmitter<{action: DropMenuAction, reference: any, bounds: any}>();

  @ViewChild('mediaScroller') mediaScroller!: ElementRef;
  @ViewChildren('mycard') mycard!: QueryList<ElementRef>;
  errorImg: string = "assets/nonimage-preview/Large-Icons/Broken-Image.png";

  ngOnInit(): void {
  } 

  scrollMMRight() {
    this.leftView--;
    this.rightView++;
    this.performScroll('right');
  }

  scrollMMLeft() {
    this.leftView++;
    this.rightView--;
    this.performScroll('left');
  }

  scrollRight(ele: HTMLElement) {
    this.performElementScroll(ele, 'right');
  }

  scrollLeft(ele: HTMLElement) {
    this.performElementScroll(ele, 'left');
  }

  private performScroll(direction: 'left' | 'right') {
    const ele = this.mediaScroller.nativeElement;
    this.performElementScroll(ele, direction);
    this.setVisible();
  }

  private performElementScroll(ele: HTMLElement, direction: 'left' | 'right') {
    const width = ele.getBoundingClientRect().width;
    const offset = (direction === 'right') ? width / 2 : -width / 2;
    ele.scrollBy(offset, 0);
  }

  clickedAction($event: any, i: number){
    $event.bounds =  this.mycard.toArray()[i].nativeElement.getBoundingClientRect();
    if($event.action == DropMenuAction.Download){     
      window.open($event.reference.originalMediaUrl, "_blank");
    }

    this.action.emit($event);
  }  

  onItemError(event: any) {
    event.target.src = this.errorImg;
  }
  setVisible() {
    // Define the valid number of images excluding the two that are already visible
    const validImages = this.items.length - 2;

    // Determine the visibility of the left view
    this.isLeftView = this.leftView < 0;

    // Determine the visibility of the right view
    if (this.rightView === validImages) {
        this.isRightView = false;
    } else if (this.rightView === 0 || validImages > this.rightView) {
        this.isRightView = true;
    }
}

  ngOnChanges(changes: SimpleChanges) {
    this.setVisible();
  }
}
